import { OwnUpSmallSubheadlineMedium, SAGE_100 } from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';
import { displayNumber } from '../../common/utils';
import { LoanTermToNumber, useRentOrBuy } from '../data/dataProvider';

const HeaderWrapper = styled(OwnUpSmallSubheadlineMedium)`
  padding-top: 0 !important;
  margin-bottom: 8px !important;
`;

const ResultPlate = styled.div`
  background-color: ${SAGE_100};
  border-radius: 8px;
  padding: 16px;
`;

export const MainCalculationResult: React.FC = () => {
  const {
    state: { loanTerm, howLongBeforeSelling },
    getBenefitOfBuying
  } = useRentOrBuy();
  return (
    <>
      <ResultPlate>
        <HeaderWrapper variant="h2">
          After {howLongBeforeSelling} years, opting for a {LoanTermToNumber[loanTerm]} year
          mortgage to purchase a home yields financial benefits amounting to{' '}
          {displayNumber(getBenefitOfBuying())}.
        </HeaderWrapper>
      </ResultPlate>
    </>
  );
};
